import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import transalationEn from './transalationEn.json';
import transalationFr from './transalationAr.json';

//Transalation
const resources = {
	en:{
		translation : transalationEn
	},
	ar:{
		translation : transalationFr
	}
};

i18n
.use(initReactI18next)
.init({
	resources,
    lng: 'en',
    preload: true,
    keySeparator: false,
    //debug: true,
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
});

export default i18n;